import { Pipe, PipeTransform } from '@angular/core';
import { Duties } from '../Model/Duties.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dutiesFilter',
  standalone: false
})
export class DutiesFilterPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(dutiesList: Duties[], searchTerm: string, field?: string): Duties[] {
    if (!dutiesList || !searchTerm?.trim()) {
      return dutiesList;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return dutiesList.filter(item => {
      if (field && item[field] != null) {
        const value = this.formatValue(item[field], field);
        return value.includes(lowerSearch);
      }

      const defaultFields = [
        'marketCompanyName',
        'brandQualityLabel',
        'brandName',
        'VAT',
        'size',
        'unitAmount',
        'UserId',
        'LastUpdateDate',
        'UserName',
        'applicationDate'
      ];

      return defaultFields.some(key => {
        const value = this.formatValue(item[key], key);
        return value.includes(lowerSearch);
      });
    });
  }

  private formatValue(value: any, field: string): string {
    if (value == null) return '';

    if (['LastUpdateDate', 'applicationDate'].includes(field)) {
      const formatted = this.datePipe.transform(value, 'MMMM dd, yyyy');
      return formatted ? formatted.toLowerCase() : '';
    }

    return value.toString().toLowerCase();
  }
}
